import { ofType } from 'redux-observable';
import { combineLatest } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { EpicWithThunk } from 'state/state.common';
import { workspaceTabsFetchRequested } from 'state/workspaces/workspace.actions';

export function navigateToEssentialWorkspaceEpic(): EpicWithThunk {
  return action$ => {
    const navigationToEssentialQuoteForm$ = action$.pipe(
      ofType('ROUTE_CHANGED'),
      filter(({ path }) => path === '/essential'),
    );

    const userInfoReceived$ = action$.pipe(ofType('USER_CURRENT_RECEIVED'));

    const productReferentialLoaded$ = action$.pipe(
      ofType('PRODUCTS_REFERENTIAL_LOADED', 'PRODUCTS_REFERENTIAL_LOADING_FAILED'),
    );

    return combineLatest([navigationToEssentialQuoteForm$, userInfoReceived$, productReferentialLoaded$]).pipe(
      take(1),
      map(() => workspaceTabsFetchRequested('essential')),
    );
  };
}
